import type { Post } from '../../../feedsSlice'

const expandRepliesToLevel = (posts: Post[], level = 3): Post[] => {
  if (!Array.isArray(posts) || posts.length === 0) return posts

  const post = posts[0]
  const feed = post.replies?.find((p) => !p.isHighlightCopy)
  const firstReplyLevel = feed?.path?.length

  const firstCommentLevel = firstReplyLevel ? firstReplyLevel : 0

  const cloneAndMark = (node: Post): Post => {
    const nodeLevel = node?.path?.length || 0
    const relativeLevel = nodeLevel - firstCommentLevel

    const shouldOpen = relativeLevel < level

    const nextReplies = Array.isArray(node.replies)
      ? node.replies.map(cloneAndMark)
      : node.replies

    return {
      ...node,
      ...(shouldOpen ? { isOpen: true } : {}),
      replies: nextReplies,
    }
  }

  return posts.map(cloneAndMark)
}

export default expandRepliesToLevel
